/* The Willow Collective — Theme JS */

// ————— Mobile Menu —————
(function() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.getElementById('mobile-nav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function() {
    const isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
    nav.setAttribute('aria-hidden', !isOpen);
  });
})();

// ————— Search Modal —————
function openSearch() {
  const modal = document.getElementById('search-modal');
  if (!modal) return;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  setTimeout(function() {
    modal.querySelector('.search-modal__input').focus();
  }, 80);
  document.body.style.overflow = 'hidden';
}
function closeSearch() {
  const modal = document.getElementById('search-modal');
  if (!modal) return;
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeSearch();
});
document.getElementById('search-modal')?.addEventListener('click', function(e) {
  if (e.target === this) closeSearch();
});

// ————— Announcement Bar Dismiss —————
document.querySelector('.announcement-bar__close')?.addEventListener('click', function() {
  const bar = this.closest('.announcement-bar');
  if (!bar) return;
  bar.style.display = 'none';
  try { sessionStorage.setItem('wc-announcement-hidden', '1'); } catch(e) {}
});
try {
  if (sessionStorage.getItem('wc-announcement-hidden') === '1') {
    const bar = document.querySelector('.announcement-bar');
    if (bar) bar.style.display = 'none';
  }
} catch(e) {}

// ————— Product Gallery Thumbnails —————
(function() {
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
      const src = this.querySelector('img')?.src;
      if (src) mainImg.src = src;
    });
  });
})();

// ————— Quantity Selectors —————
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('qty-btn')) {
    const input = e.target.closest('.quantity-selector')?.querySelector('.qty-input');
    if (!input) return;
    let val = parseInt(input.value) || 1;
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || 999;
    if (e.target.dataset.action === 'minus') val = Math.max(min, val - 1);
    if (e.target.dataset.action === 'plus') val = Math.min(max, val + 1);
    input.value = val;
  }
});

// ————— Variant Buttons —————
(function() {
  const variantBtnGroups = document.querySelectorAll('.variant-btns');
  variantBtnGroups.forEach(function(group) {
    const btns = group.querySelectorAll('.variant-btn');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (this.classList.contains('is-unavailable')) return;
        btns.forEach(function(b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        const input = group.previousElementSibling?.querySelector('input[name^="id"]') ||
                      group.closest('form')?.querySelector('input[name="id"]');
        if (input && this.dataset.variantId) input.value = this.dataset.variantId;
      });
    });
    btns[0]?.classList.add('is-selected');
  });
})();

// ————— AJAX Add to Cart —————
(function() {
  const form = document.querySelector('.product-form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn = form.querySelector('.product-form__add');
    if (!btn || btn.disabled) return;
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.textContent = 'Added!';
      updateCartCount();
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1800);
    })
    .catch(function() {
      btn.textContent = 'Error — try again';
      btn.disabled = false;
    });
  });
})();

// ————— Update Cart Count in Header —————
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      const countEl = document.querySelector('.cart-count');
      if (!countEl) {
        if (cart.item_count > 0) {
          const btn = document.querySelector('.header-icon-btn[href*="cart"]');
          if (btn) {
            const count = document.createElement('span');
            count.className = 'cart-count';
            count.textContent = cart.item_count;
            btn.appendChild(count);
          }
        }
        return;
      }
      if (cart.item_count > 0) {
        countEl.textContent = cart.item_count;
      } else {
        countEl.remove();
      }
    });
}

// ————— Newsletter Form —————
(function() {
  const form = document.querySelector('.newsletter__form-el');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const email = form.querySelector('input[type="email"]')?.value;
    const success = form.closest('.newsletter__inner')?.querySelector('.newsletter__success');
    const error = form.closest('.newsletter__inner')?.querySelector('.newsletter__error');
    if (!email) return;
    if (success) success.style.display = 'block';
    if (error) error.style.display = 'none';
    form.reset();
  });
})();

// ————— Cart — Remove Item —————
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('cart-item__remove')) {
    e.preventDefault();
    const key = e.target.dataset.key;
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function() { location.reload(); });
  }
});

// ————— Smooth Scroll to Section Links —————
document.querySelectorAll('a[href^="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
